import { STORAGE_KEYS as i } from "../managers/storage-manager.js";
const T = {
  Qs: { Xa: "d", Os: "cc", xi: "ff", Xi: "t" },
  Lu: e => {
    if (e) return e.v(i.k.Pa);
  },
  qu: (e, t) => {
    e && e.D(i.k.Pa, t);
  },
  Ea: (e, t) => {
    if (!e || !t) return -1;
    const r = T.Lu(e);
    if (null == r) return -1;
    const s = r[t];
    return null == s || isNaN(s) ? -1 : s;
  },
  Xs: (e, t, r) => {
    if (!e || !t) return;
    let s = T.Lu(e);
    null == s && (s = {}), (s[t] = r), T.qu(e, s);
  }
};
export default T;
